const removeSpecialCharacters = (str) => str.replace(/[^a-zA-Z0-9]/g, '')

export default removeSpecialCharacters